import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
} from "recharts";
import { Typography, Paper ,Box} from "@mui/material";

const Top5ProjectsByBudgetChart = ({ projects }) => {
  if (!projects || projects.length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 2, height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography align="center">Aucun projet trouvé.</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{
      p: 2,
      height: "100%",        
      width: "100%",         
      display: "flex",
      flexDirection: "column",
      borderRadius: 2,
    }}>

    <Box sx={{ flexGrow: 1  }}>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={projects}
          layout="vertical"
          margin={{ top: 20, right: 100, left: 30, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            tickFormatter={(value) => value.toLocaleString()}
            domain={[0, 'dataMax']}
            label={{ value: 'Budget (MAD)', position: 'insideBottomRight', offset: -10 }}
          />
          <YAxis
            dataKey="title" //"project_code"
            type="category"
            tick={{ fontSize: 14 }}
            width={180}
          />
          <Tooltip formatter={(value) => new Intl.NumberFormat().format(value) + ' MAD'} />
          <Bar dataKey="realized_budget" fill="#1976d2" barSize={28} radius={[5, 5, 5, 5]}>
            <LabelList
              dataKey="realized_budget"
              position="right"
              formatter={(value) => value.toLocaleString() + " MAD"}
              style={{ fill: "#1976d2", fontWeight: "bold" }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default Top5ProjectsByBudgetChart;
